export default __webpack_public_path__ + "static/media/dollar.5eec3e3f.svg";